module.exports = __webpack_public_path__ + "img/1.01.thmb.38bf2018.jpg";